import { Descriptions } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { formatPLN } from '../../../utils/helpers/formatNumber';
import useWindowSize from '../../../utils/hooks/useWindowSize';
import { PartialResult } from '../../../store/sumUp';
import { GRID_SM } from '../../../styles';
import { DescFullWidth } from '../../../styles/ui';

const DetailsPeriodInterestSum = ({ partialResult }: { partialResult: PartialResult }) => {
  const { width } = useWindowSize();
  const { t } = useTranslation();
  return (
    <DescFullWidth
      layout={width > GRID_SM ? 'horizontal' : 'vertical'}
      column={2}
      bordered
      key={partialResult.key}
    >
      <Descriptions.Item
        label={`${t('detailsPeriodInterestSum.desc')} ${formatPLN(partialResult.claimSum)}`}
      >
        <Sum>{`${formatPLN(partialResult.interestsSum)}`}</Sum>
      </Descriptions.Item>
    </DescFullWidth>
  );
};

export default DetailsPeriodInterestSum;

const Sum = styled.div`
	font-size: 15px;
	font-weight: 600;
`;
